/**
 * Page de connexion - React Vite
 */

import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../hooks/useAuth';
import { LoginForm } from '../components/forms/LoginForm';
import { getAccueilParRole } from '@shared/utils/getAccueilParRole';

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, requires2FA, requires2FAConfiguration, user } = useAuth();

  // Redirection si déjà authentifié
  useEffect(() => {
    if (isAuthenticated && !requires2FA) {
      // Respecter le ?redirect= ou location.state.from si présent
      const redirectFrom = (location.state as any)?.from?.pathname;
      const destination = redirectFrom || getAccueilParRole(user?.role);
      navigate(destination, { replace: true });
    } else if (requires2FA && requires2FAConfiguration) {
      navigate('/auth/2fa-setup');
    } else if (requires2FA && !requires2FAConfiguration) {
      navigate('/auth/2fa');
    }
  }, [isAuthenticated, requires2FA, requires2FAConfiguration, navigate, user, location]);

  const handleSuccess = () => {
    // La redirection se fait via useEffect
  };

  const handleError = (error: string) => {
    toast.error(error || 'Erreur de connexion');
  };

  const handleForgotPassword = () => {
    navigate('/auth/reset-password');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-raised py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="bg-surface rounded-lg shadow-lg p-8">
          <LoginForm
            onSuccess={handleSuccess}
            onError={handleError}
            showForgotPassword
            onForgotPassword={handleForgotPassword}
          />
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
